import { Grid, Paper, Tabs } from '@material-ui/core';
import useNav from '@opsbase/web-nav/useNav';
import FeaturedTab from '@opsbase/web-tabs/FeaturedTab';
import FeaturedRoute from '@opsbase/web-ui/FeaturedRoute';
import classnames from 'classnames';
import React, { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
export function PageRouter(props) {
    const { classes, pageRoutes = [], defaultPageRoute, scroll = false, upperCase = false, centeredTabs = false, narrowTabs = false, noHistory = false, } = props;
    const { replaceTo } = useNav();
    const [currentPageRoute, setCurrentPageRoute] = useState('');
    const { pathname } = useLocation();
    const pathPageRoute = pageRoutes.find(({ route }) => (pathname || '').startsWith(route));
    const selectedPageRoute = pageRoutes.find(tab => tab.route === currentPageRoute && !tab.disabled)
        ? currentPageRoute
        : pathPageRoute
            ? pathPageRoute.route
            : defaultPageRoute;
    const tabClass = classnames(upperCase ? classes.uppertab : classes.tab, narrowTabs ? classes.narrowtab : '');
    let selectedPageComponent = noHistory
        ? (pageRoutes.find(tab => tab.route === selectedPageRoute) || {
            component: '',
        }).component
        : null;
    selectedPageComponent =
        typeof selectedPageComponent === 'function'
            ? selectedPageComponent()
            : selectedPageComponent;
    const handleChangeTab = useCallback((event, v) => {
        setCurrentPageRoute(v);
        if (!noHistory)
            replaceTo(v);
    }, [noHistory, replaceTo]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Paper, { elevation: 0, square: true, className: classes.root },
            React.createElement(Tabs, { centered: centeredTabs, value: selectedPageRoute, onChange: handleChangeTab, indicatorColor: "primary", textColor: "primary" }, pageRoutes.map((tab, idx) => tab.label &&
                !tab.disabled && (React.createElement(FeaturedTab, { key: idx, flag: tab.flag, label: tab.label, value: tab.route, classes: { root: tabClass } }))))),
        React.createElement(Grid, { className: classes.body, style: {
                overflow: scroll ? 'auto' : 'hidden',
            } },
            noHistory && selectedPageComponent,
            !noHistory &&
                pageRoutes.map((tab, idx) => (React.createElement(FeaturedRoute, { key: idx, flag: tab.flag, path: tab.route, component: tab.component }))))));
}
export default PageRouter;
